export const data = [
  {
    title: "My Portfolio",
    description: `This is my personal portfolio, built from scratch with React.js and Material UI. It highlights my skills, projects, and professional journey as a Full-Stack Engineer.`,
    github: null,
    link: "https://farahdridi.netlify.app/",
    techs: [
      {
        img_url: [
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redux/redux-original.svg",
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/materialui/materialui-original.svg",
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg"
        ]
      }
    ],
  },
  {
    title: "Voice Interactive AI",
    description:
      "A web app where users can interact with a simple AI using voice commands, built with React.js, react-speech-kit, react-speech-recognition, and EdenAI.",
    github: null,
    link: "https://myaichat.netlify.app/",
    techs: [
      {
        img_url: [
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg"
        ]
      }
    ],
  },
  {
    title: "Quarkus Practice",
    description:
      "This project demonstrates various capabilities of Quarkus, a supersonic subatomic Java framework.",
    github: null,
    link: "https://github.com/FarahDvp/quarkus-practice",
    techs: [
      {
        img_url: [
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg",
          "https://raw.githubusercontent.com/devicons/devicon/6910f0503efdd315c8f9b858234310c06e04d9c0/icons/quarkus/quarkus-original.svg",
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg",
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kubernetes/kubernetes-plain.svg",
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/apachekafka/apachekafka-original.svg",
        ]
      }
    ],
  },
  {
    title: "Fraud Detection Microservices",
    description:
      "Developed scalable microservices architecture using Spring Boot and Spring Cloud, leveraging Kubernetes for container orchestration and efficient resource management.",
    github: null,
    link: "https://github.com/FarahDvp/fraud-detection-microservices",
    techs: [
      {
        img_url: [
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg",
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/spring/spring-original.svg",
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg",
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg",
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain.svg",
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg",
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kubernetes/kubernetes-plain.svg",
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/apachekafka/apachekafka-original.svg"
        ]
      }
    ],
  },
  {
    title: "A Complete Integration Project Between Spring Boot and Keycloak",
    description:
      "This project demonstrates the implementation of secure authentication using OAuth2 and OpenID Connect.",
    github: null,
    link: "https://github.com/FarahDvp/keycloak-spring-boot",
    techs: [
      {
        img_url: [
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg",
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/spring/spring-original.svg",
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg",
        ]
      }
    ],
  },
  {
    title: "Task Manager App",
    description: `A task management application that allows users to create, update, categorize, and track tasks with due dates, while supporting user authentication, role-based access, and detailed reporting.`,
    github: null,
    link: "https://github.com/FarahDvp/task-manager-app",
    techs: [
      {
        img_url: [
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/angularjs/angularjs-original.svg",
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg",
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/spring/spring-original.svg",
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg",
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nginx/nginx-original.svg",
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg",
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/gitlab/gitlab-original.svg",
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/karma/karma-original.svg",
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jasmine/jasmine-original.svg",
        ]
      }
    ],
  },
  {
    title: "Node.js API for Post Management",
    description:
      "A simple Node.js API with full Docker and Docker Compose configuration for seamless deployment.",
    github: null,
    link: "https://github.com/FarahDvp/dockerized-node-mongodb",
    techs: [
      {
        img_url: [
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg",
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg",
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nginx/nginx-original.svg",
        ]
      }
    ],
  },

];


